export function refreshToken() {
    //  const cookies = new Cookies();
    const user = JSON.parse(localStorage.getItem('rumbosUser'));
    return user ? user.refresh_token : '';
}

export function authHeader() {
    //   const cookies = new Cookies();
    const user = JSON.parse(localStorage.getItem('rumbosUser'));
    return {'Authorization': `Bearer ${user ? user.access_token : ''}`};
}

export function tengoRol(roles) {
    let tengoRol = false;

    try {
        //const cookies = new Cookies();
        const user = JSON.parse(localStorage.getItem('rumbosUser'));
        if (!user) return tengoRol;
        const rolesCookie = user.roles;
        if (rolesCookie !== undefined) tengoRol = rolesCookie.some(rol => roles.includes(rol));
    } catch (err) {
        console.warn(err);
    }
    return tengoRol;
}


export const ORIGEN_NOTIFICACION = {
    COMPRA: 1,
    EVENTO: 2,
    PROGRAMA: 3,
    GENERAL: 4,
    CONSULTAS: 5,
    GRUPO: 6
}


export const RoleID = {
    DEV: 4,
    ADMIN: 1,
    USER_ADMIN: 3,
    USER: 2
}

export const Role = {
    DEV: 'ROLE_DESARROLLADOR',
    ADMIN: 'ROLE_ADMIN',
    USER_ADMIN: 'ROLE_USER_ADMIN',
    USER: 'ROLE_USER'
}
